var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _vm._m(0),
        _c("div", { staticClass: "row" }, [
          _vm.succeded
            ? _c("div", { staticClass: "col-sm-12" }, [
                _c("p", [
                  _vm._v(
                    " Your email address has been confirmed! Please click "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.clientUrl,
                        "data-testid": "confirmedLink"
                      }
                    },
                    [_vm._v("here")]
                  )
                ])
              ])
            : _vm._e(),
          !_vm.succeded && _vm.loaded
            ? _c("div", { staticClass: "col-sm-12" }, [
                _c("div", { staticClass: "text-danger" }, [
                  _vm._v(
                    "There has been a problem confirming your email, please try again or contact your administrator."
                  )
                ])
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("h2", { attrs: { id: "title-of-block-check" } }, [
          _vm._v("Confirm Email")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }